import { Modal, Button, Avatar } from "antd";
import React from "react";
import ComputerIcon from "@material-ui/icons/Computer";

const SwitchToDesktopModal = ({ handleOk, isModalOpen }) => {
  return (
    <Modal
      open={isModalOpen}
      closable={false}
      footer={
        <div
          onClick={handleOk}
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            padding: "12px 24px",
            color: "white",
            background: " #2A71D4",
            borderRadius: " 6px",
            cursor: "pointer",
          }}
        >
          Got it
        </div>
      }
      className="switch-to-desktop-modal"
    >
      <Avatar
        icon={
          <ComputerIcon style={{ color: "#A1BDE5", height: 35, width: 35 }} />
        }
        style={{ backgroundColor: "#F1F5F9" }}
        size={56}
      />
      <p className="title">Go to Desktop for a beter experience!</p>
      <p className="desc">
        Some features are disabled on mobile, such as creating and managing
        posts. In order to use these features and have a seamless experience, we
        recommend switching to desktop screen.
      </p>
    </Modal>
  );
};

export default SwitchToDesktopModal;
